import { onBeforeUnmount, onMounted, ref } from 'vue';
import { MOBILE_MAX_PX } from '@/constants/layout-breakpoints';

/**
 * 与 _layout.scss / layout-breakpoints.js 一致的布局断点。
 * @param {number} [maxWidth=MOBILE_MAX_PX]
 */
export function useLayoutBreakpoint(maxWidth = MOBILE_MAX_PX) {
  const isMobile = ref(false);

  function sync() {
    if (typeof window === 'undefined') {
      isMobile.value = false;
      return;
    }
    isMobile.value = window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
  }

  // 立即同步，避免 setup / immediate watch 在 onMounted 前误判为 PC
  sync();

  onMounted(() => {
    sync();
    window.addEventListener('resize', sync);
  });

  onBeforeUnmount(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', sync);
    }
  });

  return { isMobile, sync };
}
